import React from "react";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import styles from "./style.module.scss";

export default function Managers({ manager }) {
  const { firstName, lastName, university, headshot, email } = manager;

  return (
    <li className={styles.manager}>
      <div>
        <div className={styles.bioPic}>
          <Img
            className={styles.image}
            fluid={headshot.fluid}
            title={`${firstName} ${lastName}`}
            alt={`${firstName} ${lastName}`}
          />
        </div>
        <h3 className={styles.name}>{firstName}</h3>
      </div>
      <div className={styles.expanded}>
        <div className={styles.inner}>
          <span>{`${firstName} ${lastName}`}</span>
          <hr />
          <span>{university}</span>
          {email && (
            <a href={`mailto:${email}`} className={styles.contact}>
              Contact
            </a>
          )}
        </div>
      </div>
    </li>
  );
}

Managers.propTypes = {
  manager: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    university: PropTypes.string.isRequired,
    headshot: PropTypes.object.isRequired,
    email: PropTypes.string,
    phone: PropTypes.string,
    onClick: PropTypes.func.isRequired
  }).isRequired
};
